var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.shows ? _c('page-section', {
    staticClass: "page-section--xs pt-0"
  }, [_c('template', {
    slot: "containerImmersive"
  }, [_c('v-card', {
    staticClass: "contract-card",
    attrs: {
      "color": "grey lighten-5",
      "rounded": "xl"
    }
  }, [_c('v-card-title', [_c('h4', {
    staticClass: "txt txt--sm txt--dark font-weight-medium"
  }, [_vm._v("리본바이옴 판매 계약서")])]), _c('v-spacer'), _c('v-card-text', [_c('v-row', {
    staticClass: "ma-n1 ma-md-n2"
  }, [_vm.createdAt ? _c('v-col', {
    staticClass: "pa-1 pa-md-2",
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "txt txt--xs"
  }, [_c('span', {
    staticClass: "txt--dark mr-1"
  }, [_vm._v("등록일")]), _c('span', {
    staticClass: "grey--text text--lighten-1"
  }, [_vm._v(_vm._s(_vm.createdAt))])])]) : _vm._e(), _vm.signedAt ? _c('v-col', {
    staticClass: "pa-1 pa-md-2",
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "txt txt--xs"
  }, [_c('span', {
    staticClass: "txt--dark mr-1"
  }, [_vm._v("서명일")]), _c('span', {
    staticClass: "grey--text text--lighten-1"
  }, [_vm._v(_vm._s(_vm.signedAt))])])]) : _vm._e()], 1)], 1), _c('v-card-actions', [_vm.isSigned ? _c('contract-view', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "rounded-sm v-size--xx-small px-3",
          attrs: {
            "color": "primary",
            "outlined": ""
          }
        }, 'v-btn', attrs, false), on), [_vm._v("계약서 보기")])];
      }
    }], null, false, 2219989041)
  }) : _c('contract-sign', _vm._g({
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref2) {
        var on = _ref2.on,
          attrs = _ref2.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "rounded-sm v-size--xx-small px-3 ml-2",
          attrs: {
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_vm._v("서명하기")])];
      }
    }], null, false, 1229109037)
  }, {
    init: _vm.init
  }))], 1)], 1)], 1)], 2) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }